import React from "react";
import * as S from "./ChatInterfaceStyles";
import { CardSpec } from "./MessagePreprocessor";

interface CardsProps {
  cards: CardSpec[];
  onAction?: (action: { label: string; action: string; params?: Record<string, any> }, card: CardSpec) => void;
}

const Cards: React.FC<CardsProps> = ({ cards, onAction }) => {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 10 }}>
      {cards.map((c, idx) => (
        <div key={idx} style={{ background: "var(--surface-color)", borderRadius: 6, padding: 10, boxShadow: "0 1px 3px rgba(0,0,0,0.08)", border: "1px solid var(--border-color)" }}>
          <div style={{ fontWeight: 600, fontSize: 13, color: "var(--primary-color)" }}>{c.title}</div>
          {c.subtitle && <div style={{ color: "var(--text-muted)", marginTop: 4, fontSize: 12 }}>{c.subtitle}</div>}
          {c.tags && c.tags.length > 0 && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 6 }}>
              {c.tags.map(t => (
                <span key={t} style={{ background: "var(--surface-muted)", color: "var(--primary-color)", padding: "2px 6px", borderRadius: 10, fontSize: 11 }}>{t}</span>
              ))}
            </div>
          )}
          {c.meta && (
            <div style={{ marginTop: 6, fontSize: 11, color: "var(--primary-color)" }}>
              {Object.entries(c.meta).map(([k, v]) => (
                <div key={k}><strong>{k}:</strong> {String(v)}</div>
              ))}
            </div>
          )}
          {c.actions && c.actions.length > 0 && (
            <div style={{ display: "flex", gap: 6, marginTop: 8, flexWrap: "wrap" }}>
              {c.actions.map((a, i) => (
                <button
                  key={i}
                  onClick={() => onAction && onAction(a, c)}
                  style={{ background: "#FFA325", color: "#fff", border: 0, borderRadius: 6, padding: "5px 8px", cursor: "pointer", fontSize: 12 }}
                >
                  {a.label}
                </button>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Cards;
